module.exports = __webpack_public_path__ + "static/logo_white2_shadow-642eb9b5798584bd45a1a356556cf28b.png";